import { EncryptStorage } from "encrypt-storage";

const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);

export function getUserInfo() {
  try {
    const userInfo = encryptStorage.getItem("___info");
    const baseURL = process.env.REACT_APP_SERVICE;
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo?.token || ""}`,
        "Access-Control-Allow-Origin": true,
        "Access-Control-Allow-Credentials": true,
        "Accept-Language": "en",
      },
    };
    return { baseURL, userInfo, config };
  } catch (error) {
    console.error("Failed to retrieve user info:", error);
    return null;
  }
}
